import React from 'react';
import './home.scss';
import appConfig from '../../app-config';
import { apiImagesMetadata } from '../../api/images-metadata';
import Lightbox from "yet-another-react-lightbox";
import PhotoAlbum from "react-photo-album";
import "react-photo-album/rows.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { shuffle, logInfo } from '../../utils/utils';

const imagesHostname = appConfig.api.images;

export default class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      index: -1,
      photos: [],
    };
  }

  setIndex(idx) {
    this.setState({
      index: idx
    });
  }

  async componentDidMount() {
    await this.loadImagesMetadata();
  }

  parseImageTags = (tags) => {
    const keywords = tags.find(tag => tag.Key === "keywords");
    if (keywords) {
      return keywords.Value.split('+').filter(tag => tag.trim());
    }
    return [];
  };

  getLongestTag = (tags) => {
    if (!tags || tags.length === 0) {
      return null;
    }
    
    return tags.reduce((longest, currentTag) => {
      return currentTag.length > longest.length ? currentTag : longest;
    });
  };

  loadImagesMetadata = async () => {
    let images = await apiImagesMetadata();

    let imagesJson = JSON.parse(images);

    logInfo('Images metadata');
    logInfo(imagesJson);

    images = imagesJson.map(({ asset, alt, width, height, format, orientation, tags }) => {
      const parsedTags = this.parseImageTags(tags);
      const longestTag = this.getLongestTag(parsedTags);

      return {
        src: `https://${imagesHostname}/${asset}`,
        alt: parsedTags.join(', '),
        title: longestTag,
        width,
        height,
        format,
        orientation,
        tags: parsedTags
      };
    });

    shuffle(images);

    this.setState({
      photos: images
    });
  }

  render() {
    const { photos, index } = this.state;

    logInfo('Photos loaded')
    logInfo(photos)

    return (
      <React.Fragment>
        <div className={'fp-server-photo-album'}>
          <PhotoAlbum
            layout="rows"
            photos={photos}
            targetRowHeight={300}
            breakpoints={[640, 768, 1024, 1280]}
            sizes={{
              size: "1400px",
              sizes: [
                { viewport: "(max-width: 640px)", size: "calc(100vw - 16px)" },
                { viewport: "(max-width: 1200px)", size: "calc(100vw - 64px)" }
              ],
            }}
            onClick={({ index }) => this.setIndex(index)}
          />
        </div>

        <Lightbox
          slides={photos}
          open={index >= 0}
          index={index}
          close={() => this.setIndex(-1)}
        />
      </React.Fragment>
    )
  }
};